"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GENERATE_MAX_AHEAD = void 0;
exports.sum = sum;
const core_1 = require("@js-joda/core");
__exportStar(require("./company-information"), exports);
__exportStar(require("./FeatureFlags"), exports);
__exportStar(require("./HttpInterface"), exports);
__exportStar(require("./interface/ai-visibility"), exports);
__exportStar(require("./interface/canva"), exports);
__exportStar(require("./interface/guidelines"), exports);
__exportStar(require("./interface/heygen"), exports);
__exportStar(require("./interface/inbox"), exports);
__exportStar(require("./interface/notifications"), exports);
__exportStar(require("./interface/onboard"), exports);
__exportStar(require("./interface/seo-audit"), exports);
__exportStar(require("./interface/seo-reporting"), exports);
__exportStar(require("./interface/video-generation"), exports);
__exportStar(require("./interface/wordpress"), exports);
__exportStar(require("./media"), exports);
__exportStar(require("./platform-auth-error"), exports);
__exportStar(require("./post-constraints"), exports);
__exportStar(require("./post-label"), exports);
__exportStar(require("./post-queue"), exports);
__exportStar(require("./supported-files"), exports);
__exportStar(require("./tiktok-media"), exports);
__exportStar(require("./types/billing-addon-slug.enum"), exports);
__exportStar(require("./types/billing-interval.enum"), exports);
__exportStar(require("./types/billing-plan-slug.enum"), exports);
__exportStar(require("./types/carousel.types"), exports);
__exportStar(require("./types/company-user-role.enum"), exports);
__exportStar(require("./types/goal.enum"), exports);
__exportStar(require("./types/google"), exports);
__exportStar(require("./types/image-generation.types"), exports);
__exportStar(require("./types/locations"), exports);
__exportStar(require("./types/meta-ads"), exports);
__exportStar(require("./types/platform.enum"), exports);
__exportStar(require("./types/platform-profile"), exports);
__exportStar(require("./types/platform-status"), exports);
__exportStar(require("./types/post_status.enum"), exports);
__exportStar(require("./types/reviews"), exports);
__exportStar(require("./types/tiktok-ads"), exports);
__exportStar(require("./types/tiktok-ads-matrix"), exports);
__exportStar(require("./types/time-period.enum"), exports);
__exportStar(require("./types/youtube"), exports);
__exportStar(require("./types/youtube-connection"), exports);
__exportStar(require("./x-api-costs"), exports);
__exportStar(require("./x-copy-standard"), exports);
__exportStar(require("./x-post-url"), exports);
__exportStar(require("./youtube-categories"), exports);
__exportStar(require("./youtube-media"), exports);
__exportStar(require("./zod"), exports);
/**
 * The maximum duration a user can generate posts for.
 * If 7 days - means a user can plan for a week ahead and
 * approve the posts for a week ahead only.
 */
exports.GENERATE_MAX_AHEAD = core_1.Period.ofDays(45);
function sum(...values) {
    return values.reduce((a, b) => a + b, 0);
}
